import ApiService from '@/core/services/api.service';

/**
 * Client cho HealthReportController (DiaB.WebApi) — GĐ3 Portal Review.
 * Gọi qua $api chuẩn của app (VUE_APP_API), KHÔNG phải gateway riêng như SDK Partner.
 */
const api = new ApiService();

export default {
  // GET /HealthReport?state=&search=&page=&size=
  getPaging(params = {}) {
    return api.get('HealthReport', { params });
  },
  // GET /HealthReport/{id}
  getById(id) {
    return api.get(`HealthReport/${id}`);
  },
  // POST /HealthReport
  create(body) {
    return api.post('HealthReport', body);
  },
  // PUT /HealthReport — bắt buộc kèm version đang xem, sai version -> 409 (conflict)
  update(body) {
    return api.put('HealthReport', body);
  },
  // DELETE /HealthReport/{id}
  remove(id) {
    return api.delete(`HealthReport/${id}`);
  },
  // POST /HealthReport/comment
  addComment(body) {
    return api.post('HealthReport/comment', body);
  },
  // POST /HealthReport/{id}/approve — GAP1: bác sĩ duyệt báo cáo (State -> APPROVED).
  // body: { version, acknowledgeDataWarning }. Lỗi guard trả về error.code:
  //  version_conflict | not_previewed | fallback_not_acknowledged | invalid_state
  approve(id, body) {
    return api.post(`HealthReport/${id}/approve`, body);
  },
};

export const HEALTH_REPORT_STATE = {
  DRAFT: { value: 'DRAFT', label: 'Nháp', variant: 'secondary' },
  CHECK_INPUT: { value: 'CHECK_INPUT', label: 'Chờ Data Team', variant: 'info' },
  CHECK_INPUT_DONE: { value: 'CHECK_INPUT_DONE', label: 'Đã kiểm dữ liệu', variant: 'info' },
  PENDING_BS1: { value: 'PENDING_BS1', label: 'Chờ BS1', variant: 'warning' },
  BS1_DONE: { value: 'BS1_DONE', label: 'BS1 xong', variant: 'warning' },
  PENDING_BS2: { value: 'PENDING_BS2', label: 'Chờ BS2', variant: 'primary' },
  // GAP2 — BS2 đã ký, chờ người duyệt cuối cùng (bước 3) bấm duyệt để mở gate gửi thông báo KH.
  BS2_DONE: { value: 'BS2_DONE', label: 'Chờ duyệt cuối', variant: 'primary' },
  NEEDS_REVISION: { value: 'NEEDS_REVISION', label: 'Yêu cầu sửa', variant: 'danger' },
  APPROVED: { value: 'APPROVED', label: 'Đã duyệt', variant: 'success' },
  PUBLISHED: { value: 'PUBLISHED', label: 'Đã xuất bản', variant: 'success' },
  CANCELLED: { value: 'CANCELLED', label: 'Đã huỷ', variant: 'dark' },
  // Tự động gắn khi có report MỚI hơn cho cùng khách hàng (OCR chạy lại/upload lại) — báo cho BS
  // biết bản này đã lỗi thời, đừng review nhầm (PO note: "sau khi input xong reload hoặc
  // regenerate lại thì sao" — xem HealthReportService.SupersedePreviousReports ở BE).
  SUPERSEDED: { value: 'SUPERSEDED', label: 'Đã bị thay thế', variant: 'secondary' },
};
